import React from 'react';
import { motion } from 'framer-motion';
const STATS = [{
  value: '+3',
  label: 'Años de experiencia'
}, {
  value: '+80',
  label: 'Proyectos realizados'
}, {
  value: '+23',
  label: 'Clientes activos'
}, {
  value: '+5',
  label: 'Sectores atendidos'
}];
export function Stats() {
  return <section aria-label="Resultados de Vivo Media" className="w-full border-y border-vm-electric bg-vm-navy py-16 sm:py-20 lg:py-24" data-id="element-192" data-mp="2nwiq8mx0cy22">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-193" data-mp="297cj8crxi3jm">
        <div className="grid grid-cols-2 gap-y-12 lg:grid-cols-4 lg:gap-y-0" data-id="element-194" data-mp="2dym6x7tx2wsv">
          {STATS.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-48px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="first:pl-0 lg:border-r lg:border-white/15 lg:px-10 lg:last:border-r-0" data-id="element-195" data-mp="2088zd6kxtk42" data-mpi={index}>
              <div className="font-bornia text-4xl font-bold leading-none text-white sm:text-5xl lg:text-6xl" data-id="element-196" data-mp="5588hdtm8eif">
                {stat.value}
              </div>
              <p className="mt-4 max-w-[9rem] font-bornia text-xs font-medium uppercase leading-relaxed tracking-[0.25em] text-vm-muted" data-id="element-197" data-mp="8ralrwm6ls5">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}